import { Component, OnInit } from '@angular/core';

declare function require(moduleName: string): any;

@Component({
    selector: 'app-translate',
    templateUrl: './translate.component.html',
    styleUrls: ['./translate.component.scss'],
    standalone: false
})
export class TranslateComponent implements OnInit {

  jsonEditorOptions = { /*theme: 'vs-dark',*/ language: 'json', automaticLayout: true };
  xmlEditorOptions = { /*theme: 'vs-dark',*/ language: 'xml', automaticLayout: true };

  constructor() { }
  jsonEditor = null;
  xmlEditor = null;
  error: string = "this is a demo";
  ready = false;

  xmlCode = null; // require('raw-loader!./workflow.xaml');
  jsonCode = require('./flow.json');

  ngOnInit() {
    this.jsonCode = JSON.stringify(this.jsonCode, null, 4);
    this.ready = true;
  }

  onInitJson(editor) {
    //let line = editor.getPosition();
    //console.log(line);
    this.jsonEditor = editor;
    // this.editor.setValue(this._code);
    // this.editor.layout();
    //debugger
  }

  onInitXml(editor) {
    this.xmlEditor = editor;
  }

  close() {
    // if (this.windowRef) {
    //   this.windowRef.close();
    // }

    //let type = "app-plan-edit";
    // this.flowEventService.closeTabWindow$.emit({
    //   value: false,
    //   type: "app-plan-edit"
    // });
  }

}
